import React, { ChangeEvent, FC, useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import _ from "lodash";
import { Link, Prompt, useHistory, useLocation } from "react-router-dom";
import { Field, Form, Formik, FormikHelpers } from "formik";
import * as Yup from "yup";
import { DEFAULT_PER_PAGE } from "../../../../constants/common";
import axios, { AxiosError } from "axios";
import { IAxiosError } from "../../../../models/AxiosModel";
import { HTTP_UNPROCESSABLE_ENTITY } from "../../../../constants/status";
import { Toast } from "../../../../modules/common/helper";
import { ISearchProduct } from "../../../../models/OrderModel";
import { PaginateModel } from "../../../../models/PaginateModel";
import { PaginationLength } from "../../../../../_metronic/partials/pagination/PaginationLength";
import { Paginate } from "../../../../../_metronic/partials/pagination/Paginate";
import ProductTable from "./ProductTable";
import { HeaderModel, ModalModel } from "../../../../models/CommonModel";
import ConfigModal from "../../../../components/Modal/ConfigModal";
import { AsyncSelect2 } from "../../../../../_metronic/partials/select/AsyncSelect2";
import { GET_CATEGORIES_LIST, GET_SUB_CATES } from "../../../../constants/endpoints";
import { getProductList, makeRequest } from "../ImportRequestCRUD";
import { IInventoryOfSento } from "../../../../models/AgentProduct";
import { ImportRequestDetailModel } from "../../../../models/ImportRequestModel";

const Create: FC = () => {

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isDefaultPlaced = searchParams.get('createFromCart') && searchParams.get('createFromCart') === '1' ? true : false;
  const initSearch = {
    page: 1,
    per_page: 10,
    placed_products: isDefaultPlaced ? 1 : 0,
  }

  const intl = useIntl();
  const history = useHistory();
  const schema = Yup.object().shape({});

  const [products, setProducts] = useState<PaginateModel<IInventoryOfSento>>()
  const [placedProducts, setPlacedProducts] = useState<ImportRequestDetailModel[]>([])
  const [search, setSearch] = useState<ISearchProduct>(initSearch)
  const [needAlert, setNeedAlert] = useState<any>(false)
  const header: HeaderModel[] = [
    {
      label: intl.formatMessage({ id: 'PRODUCTS.NAME' }),
      field: 'name',
      style: { maxWidth: "180px", minWidth: "180px", },
      sortable: false
    },
    {
      label: 'Nhà cung cấp',
      field: 'supplier_name',
      style: { maxWidth: "180px", minWidth: "180px", },
      sortable: false
    },
    {
      label: 'Giá NCC',
      field: 'supplier_price',
      style: { minWidth: "180px", },
      sortable: false
    },
    {
      label: 'Số lượng',
      field: 'quantity',
      style: { maxWidth: "130px", minWidth: "130px", },
      sortable: false
    },
    {
      label: 'VAT',
      field: 'vat',
      style: { maxWidth: "80px", minWidth: "80px", },
      sortable: false
    },
    {
      label: 'Tồn kho',
      field: 'warehouse',
      style: { maxWidth: "80px", minWidth: "80px", },
      sortable: false
    }
  ]

  const [hideCols, setHideCols] = useState<string[]>([
   
  ]);
  const [configModal, setConfigModal] = useState<ModalModel>({
    show: false,
    mode: 'add',
  });
  useEffect(() => {
    document.title = 'Sento - Tạo yêu cầu nhập hàng ký gửi';
  })

  useEffect(() => {
    const params = { ...search }
    getListProducts(params);
  }, []);

  useEffect(() => {
    if (Object.keys(placedProducts).length > 0) {
      setNeedAlert(true)
    }
  }, [placedProducts]);

  const getListProducts = async (params: ISearchProduct) => {
    let { data } = await getProductList({ ...params });
    setProducts(data);
  }

  const handlePageLengthChange = (e: any) => {
    getListProducts({ ...search, page: 1, per_page: +e.target.value })
  }

  const handlePageChange = (data: any) => {
    getListProducts({ ...search, page: data.selected + 1 })
  }

  const handleSubmit = async (values: any, { setFieldError }: FormikHelpers<any>) => {
    try {
      const { data } = await makeRequest(placedProducts, 'new', values.note)
      setNeedAlert(false);
      Toast.fire({
        icon: 'success',
        title: data?.message || intl.formatMessage({ id: 'COMMON.SUCCESS_NOTY' }),
      })
      history.push('/warehouse/receipt/import-requests')
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError<IAxiosError>;
        if (axiosError.response?.status === HTTP_UNPROCESSABLE_ENTITY) {
          const errors = axiosError.response?.data?.errors ?? []
          Object.keys(errors)?.map((key: string) => setFieldError(key, errors[key][0]));
        }
      }
    }
  }

  const handleSaveDraft = async (values: any) => {
    try {
      const { data } = await makeRequest(placedProducts, 'draft', values.note)
      setNeedAlert(false);
      Toast.fire({
        icon: 'success',
        title: data?.message || intl.formatMessage({ id: 'COMMON.SUCCESS_NOTY' }),
      })
      history.push('/warehouse/receipt/import-requests')
    } catch (error) {
      Toast.fire({
        icon: 'error',
        title: 'Đã có lỗi xảy ra vui lòng thử lại sau!',
      })
    }
  }
  const onSearchProducts = (e: any) => {
    setSearch({ ...search, [e.target.name]: e.target.value ?? '', order_by_ids: [] });
    getListProducts({ ...search, [e.target.name]: e.target.value ?? '', order_by_ids: [] });
  }

  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSearchProducts(e);
    }
  }

  const handleCheckAll = (e: any) => {
    let placePds = [...placedProducts];
    let curPDatas = products?.data ?? [];
    if (e.target.checked) {
      _.map(curPDatas, (el: IInventoryOfSento) => {
        let iSupplier = el.best_supplier;

        if (iSupplier && !_.some(placePds, { inventory_of_supplier_id: iSupplier.id })) {
          placePds = [...placePds, {inventory_of_supplier_id: iSupplier.id, quantity: 1}]
        }
      });
    } else {
      let curPIds = _.map(curPDatas, (el: IInventoryOfSento) => {
        let iSupplier = el.best_supplier;
        return iSupplier?.id
      } );
      placePds = _.filter(placePds, function (o) { return !curPIds.includes(o.inventory_of_supplier_id) });
    }
    setPlacedProducts(placePds)
  }

  const handleSort = (sortBy: string, direction: 'asc' | 'desc' | 'none') => {
    const currentSearch = { ...search };
    const sortParams: ISearchProduct = { ...currentSearch, sort_by: sortBy, sort_direction: direction };
    if (direction === 'none') {
      delete sortParams.sort_by;
      delete sortParams.sort_direction;
    }
    getListProducts({ ...sortParams });
  }

  const handleChangeVisCols = (e: any) => {
    let hiddenCols = [...hideCols];
    if (!e.target?.checked) {
      setHideCols([...hiddenCols, e.target.name])
    } else {
      setHideCols(hiddenCols.filter((item) => item !== e.target.name))
    }
  }

  const cateRef = useRef<any>(null);
  const subCateRef = useRef<any>(null);
  const clearSearch = () => {
    setSearch(initSearch)
    cateRef?.current?.clearValue()
    if (subCateRef?.current) {
      subCateRef?.current?.clearValue()
    }
    getListProducts(initSearch)
  }

  const toggleCheck = (e: ChangeEvent<HTMLInputElement>, item: IInventoryOfSento) => {
    let iSupplier = item.best_supplier;
    if (iSupplier) { 
      let newPlaceProds = [...placedProducts];
      if (e.target.checked) {
        newPlaceProds.push({
          inventory_of_supplier_id: iSupplier.id,
          quantity: 1
        })
      } else {
        newPlaceProds = newPlaceProds.filter(el => el.inventory_of_supplier_id !== iSupplier?.id)
      }

      setPlacedProducts(newPlaceProds);
    }
  }

  const handleChangeQty = (e: ChangeEvent<HTMLInputElement>, item: IInventoryOfSento) => {
    let iSupplier = item.best_supplier;
    if (!iSupplier) { return }

    let newPlaceProds = [...placedProducts];
    let index = newPlaceProds.findIndex(el => el.inventory_of_supplier_id === iSupplier?.id);
    if (index >= 0) {
      newPlaceProds[index] = {
        ...newPlaceProds[index],
        quantity: parseInt(e.target.value),
        request_quantity: parseInt(e.target.value)
      }
    } else {
      newPlaceProds.push({
        inventory_of_supplier_id: iSupplier?.id,
        quantity: parseInt(e.target.value),
        request_quantity: parseInt(e.target.value)
      })
    }
    setPlacedProducts(newPlaceProds);
  }

  return <Formik enableReinitialize validationSchema={schema}
    initialValues={{ 
      status: null, 
      note: null, 
    }} onSubmit={handleSubmit}>
    {({ values, handleChange }) => {
      return (
        <Form>
          <Prompt
            when={needAlert}
            message="Dữ liệu đơn hàng chưa được lưu, bạn có chăc chắn muốn chuyển trang?"
          />
          <div className="card">
            <div className="card-body p-3">
              <div className="row mt-2">
                <div className="col-12 col-md-3 mb-2">
                  <input
                    type='text'
                    className='form-control'
                    name="name"
                    placeholder="Thông tin sản phẩm"
                    onBlur={(e) => onSearchProducts(e)}
                    onKeyDown={(e) => handleKeyDown(e)}
                  />
                </div>
                <div className='col-md-3 mb-2'>
                  <AsyncSelect2
                    sourceUrl={`${GET_CATEGORIES_LIST}`}
                    defaultOptions
                    default
                    forwardRef={cateRef}
                    placeholder="Danh mục cha"
                    onChange={(selectedOption: any) => {
                      if (selectedOption?.value) {
                        onSearchProducts({
                          target: {
                            name: 'category_id',
                            value: selectedOption?.value ?? '',
                            label: selectedOption?.label ?? ''
                          }
                        });
                      }
                    }}
                  />
                </div>
                {search?.category_id && (
                  <div className='col-md-3 mb-2'>
                    <AsyncSelect2
                      sourceUrl={`${GET_SUB_CATES}/${search?.category_id}`}
                      defaultOptions
                      default
                      forwardRef={subCateRef}
                      placeholder="Danh mục con"
                      onChange={(selectedOption: any) => {
                        if (selectedOption?.value) {
                          onSearchProducts({
                            target: {
                              name: 'sub_cate_id',
                              value: selectedOption?.value ?? '',
                              label: selectedOption?.label ?? ''
                            }
                          });
                        }
                      }}
                    />
                  </div>
                )}
                <div className="col-md-3 mb-2">
                  <select
                    className="form-select"
                    value={search.wh_status ?? ''}
                    onChange={(e) => onSearchProducts(e)}
                    name="wh_status"
                  >
                    <option value="">Tồn kho</option>
                    <option value="1">Dưới mức tồn kho</option>
                    <option value="2">Vượt mức tồn kho</option>
                    <option value="3">Còn hàng trong kho</option>
                    <option value="4">Hết hàng trong kho</option>
                  </select>
                </div>
                <div className="col-12 mb-2">
                  <a onClick={clearSearch} className="btn btn-danger">Clear search</a>
                </div>
              </div>
              <ProductTable
                products={products?.data}
                placedProducts={placedProducts}
                handleCheckAll={handleCheckAll}
                handleChangeQty={handleChangeQty}
                toggleCheck={toggleCheck}
                handleSort={handleSort}
                openColConfig={() => setConfigModal({ ...configModal, show: true })}
                hideCols={hideCols}
                headers={header}
              />
              
              <div className="d-flex justify-content-between paginate-wrapper">
                <PaginationLength selected={search.per_page || DEFAULT_PER_PAGE}
                  onChange={handlePageLengthChange} />
                <Paginate
                  pageCount={products?.meta?.last_page || 0}
                  onPageChange={handlePageChange}
                  forcePage={(search.page || 1) - 1}
                />
              </div>
              <hr/>
              <div className="mt-5">
                <label className="form-label">Ghi chú</label>
                <Field
                  as='textarea'
                  className="form-control"
                  rows={4}
                  id="note"
                  name="note"
                  value={values?.note || ''}
                  onChange={(e: any) => handleChange(e)}
                />
              </div>
            </div>
            <div className='card-footer py-6'>
              <div className="d-flex justify-content-center">
                <button className="btn btn-success" type="submit">Tạo mới</button>
                <button onClick={() => handleSaveDraft(values)} className="btn btn-warning mx-2" type="button">Lưu tạm</button>
                <Link to="/warehouse/receipt/list">
                  <button className="btn btn-secondary">{intl.formatMessage({ id: 'COMMON.BACK' })}</button>
                </Link>
              </div>
            </div>
          </div>
          <ConfigModal
            {...configModal}
            header={header}
            hideCols={hideCols}
            handleChangeVisCols={handleChangeVisCols}
            onClose={() => { setConfigModal({ ...configModal, show: false }) }}
          />
        </Form>

      )
    }}
  </Formik>
}
export default Create;